import React from "react";

/**
 * Highlights specified text in a given string.
 *
 * @param text - The input string to be highlighted.
 * @param highlight - The text to be highlighted.
 * @returns A JSX element with the specified text highlighted.
 */
export const Highlight = ({
  text,
  highlight,
  className,
}: {
  text: string | undefined;
  highlight: string | undefined;
  className?: string | undefined;
}): JSX.Element => {
  if (!text) {
    return <></>;
  }

  if (!highlight) {
    return <span className={className}>{text}</span>;
  }

  try {
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(escapedHighlight, "gi");
    const parts = text.split(regex);
    const matches = text.match(regex);

    if (!matches) {
      return <span className={className}>{text}</span>;
    }

    return (
      <span className={className}>
        {parts.map((part, index) => {
          if (index === parts.length - 1) {
            return part;
          }

          return (
            <React.Fragment key={index}>
              {part}
              <span className="kalo-highlight">{matches[index]}</span>
            </React.Fragment>
          );
        })}
      </span>
    );
  } catch (error) {
    console.warn("Highlight component error:", error);
    return <span className={className}>{text}</span>;
  }
};
